import { useState, useCallback } from "react";

/**
 * Persisted "sidebar collapsed" state for any of the app shells
 * (CRM / MY / MEDIA / ADMIN).
 *
 * Defaults to expanded on desktop (≥1024px) and collapsed on mobile so the
 * first render is usable without a flicker. Subsequent visits restore the
 * user's preference via localStorage.
 */
export default function useSidebarCollapsed(storageKey) {
  const [collapsed, setCollapsed] = useState(() => {
    if (typeof window === "undefined") return false;
    const stored = window.localStorage.getItem(storageKey);
    if (stored !== null) return stored === "1";
    return window.innerWidth < 1024;
  });

  const toggle = useCallback(() => {
    setCollapsed((prev) => {
      const next = !prev;
      try { window.localStorage.setItem(storageKey, next ? "1" : "0"); } catch (err) {
        // localStorage may be disabled (private mode, quota exceeded) — UI still works without persistence
        if (process.env.NODE_ENV !== "production") console.warn("useSidebarCollapsed: localStorage write failed", err);
      }
      return next;
    });
  }, [storageKey]);

  return [collapsed, toggle];
}
